import { LandedCostSettingsSchema } from "@redotech/redo-conversion-settings-common/landed-cost-settings";
import * as z from "zod";

export const getLandedCostSettings = {
  name: "getLandedCostSettings" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ landedCost: LandedCostSettingsSchema.optional() }),
};
